<template>
    <div class="w-[90%] mx-auto mt-[20px] z-[9999] relative h-[100vh]">
        <div class="text-white font-bold text-center mt-[20px] text-[21px]">Виконані домашні завдання</div>

        <div class="mb-5 pb-10 rounded-[10px] overflow-y-auto scrollbar">
            <div class="flex justify-end mb-[15px]">
                <div @click="$emit('close')" class="bg-[#BD9135] mr-[125px] flex justify-center items-center w-[228px] h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg">
                    <span>Назад</span>
                </div>
            </div>

            <div class="bg-[#252526] border-[1px] border-[#FFF] border-opacity-10 rounded-[10px] px-4 py-3">
                <div v-if="loading" class="text-center text-gray-300 py-6">Завантаження...</div>

                <div v-else>
                    <div v-if="studentsWithStatus.length === 0" class="text-center text-gray-300 py-6">
                        Немає даних про виконання дз
                    </div>

                    <table v-else class="w-full text-white">
                        <thead class="text-sm border-b-[1px] border-[#FFF] border-opacity-10">
                            <tr class="text-left">
                                <th class="py-2 w-[50px] text-center font-semibold">#</th>
                                <th class="py-2 font-semibold">Гравець</th>
                                <th class="py-2 w-[180px] text-center font-semibold">Статус</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(student, index) in studentsWithStatus" :key="student.student_id || index" class="border-b-[1px] border-[#FFF] border-opacity-5">
                                <td class="py-2 text-center text-sm text-gray-300">{{ index + 1 }}</td>
                                <td class="py-2 font-medium">{{ student.fullName }}</td>
                                <td class="py-2 text-center">
                                    <span
                                        :class="student.status === 'completed' ? 'bg-[#8FC408] text-[#252526]' : 'bg-[#DA4167] text-white'"
                                        class="px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide"
                                    >
                                        {{ student.status === 'completed' ? 'Здано' : 'Не здано' }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { computed, onMounted, ref } from 'vue'
    import { getStudentsByGroupIdRequest } from '@/desktopApp/services/apiRequests'

    export default {
        name: 'homework-attended-view',

        props: {
            training: {
                type: Object,
                required: true
            }
        },

        setup(props) {
            const loading = ref(false)
            const groupStudents = ref([])

            const completedIds = computed(() => {
                const completedList = props.training?.homework || []
                return new Set(completedList.map(student => student.player_id))
            })

            const studentsWithStatus = computed(() => {
                const source = groupStudents.value.length ? groupStudents.value : (props.training?.homework || [])
                return [...source]
                    .map(student => {
                        const studentId = student.student_id || student.id
                        const fullName = [student.surname, student.name].filter(Boolean).join(' ').trim()
                        return {
                            ...student,
                            student_id: studentId,
                            fullName: fullName || student.name || '',
                            status: completedIds.value.has(studentId) ? 'completed' : 'pending'
                        }
                    })
                    .sort((a, b) => a.fullName.localeCompare(b.fullName, 'uk', { sensitivity: 'base' }))
            })

            onMounted(async () => {
                if (!props.training?.group_id) {
                    groupStudents.value = []
                    return
                }
                console.log('props.training.group_id', props.training)
                loading.value = true
                try {
                    const res = await getStudentsByGroupIdRequest(props.training.group_id)
                    groupStudents.value = res.data || []
                } catch (error) {
                    console.error('Не вдалося завантажити учнів групи', error)
                    groupStudents.value = []
                } finally {
                    loading.value = false
                }
            })

            return {
                loading,
                studentsWithStatus
            }
        }
    }
</script>

<style lang="scss" scoped>
.scrollbar::-webkit-scrollbar {
    width: 5px;
}

.scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.scrollbar::-webkit-scrollbar-thumb {
    background-color: #696969;
    border-radius: 20px;
}
</style>